



import { BaseEntityResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseEntitiesResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseDataResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseResponse } from '@m4u-angular/base/entities/BaseEntities';
import { GenericListEntity } from '@m4u-angular/base/entities/BaseEntities';
import { DataGroupInfo } from '@m4u-angular/base/entities/BaseEntities';
import { BaseEndpoint } from '@m4u-angular/base/endpoint/BaseEndpoint';
import { BaseEndpointCRUD } from '@m4u-angular/base/endpoint/BaseEndpointCRUD';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import { APIGatewayService } from '@m4u-angular/core/gateway/APIGateway.service';
import { EnumRequestProgressTracking } from '@m4u-angular/core/framework/sysenums.enum';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Delivery } from './../entities/delivery.entity';
import { DeliveriesListParams } from './../params/deliverieslist.param';
@Injectable()
export class DeliveryEndpoint extends BaseEndpointCRUD<Delivery>
{
    constructor(api: APIGatewayService) {super("Delivery", api);}
	

    public  GetListByParams(Params: DeliveriesListParams, options: DataLoadOptions) : Observable<BaseEntitiesResponse<Delivery>>
	{
		return this.api.ExecutePostAction(this.ControllerName, 'GetListByParams', Params,  options?.GetLoadOptions() );
    }
}

